import React from 'react'
import Icon from '@ant-design/icons';

export default (props) => {
  const {
    color, // цвет знака

    width,
    height,

    style: {
      width: style_width,
      height: style_height,
      color: style_color,
    } = {},
    ...rest
  } = props;

  const fill_color = color || style_color || '#A9C6E0';

  const w = width || style_width || 20;
  const h = height || style_height || 20;

  const SvgIcon = () => (
    <svg
      width={w}
      height={h}
      viewBox={`0 0 ${w} ${h}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 2.2V4.32203C0 4.88339 0.455254 5.33898 1.01695 5.33898H4.32203C4.88339 5.33898 5.33898 4.88339 5.33898 4.32203V1.01695C5.33898 0.455593 4.88339 0 4.32203 0H2.2C0.984974 0 0 0.984974 0 2.2Z"
        fill={fill_color}
      />
      <path
        d="M0 2.2V4.32203C0 4.88339 0.455254 5.33898 1.01695 5.33898H4.32203C4.88339 5.33898 5.33898 4.88339 5.33898 4.32203V1.01695C5.33898 0.455593 4.88339 0 4.32203 0H2.2C0.984974 0 0 0.984974 0 2.2Z"
        fill={fill_color}
      />
      <path
        d="M0 2.2V4.32203C0 4.88339 0.455254 5.33898 1.01695 5.33898H4.32203C4.88339 5.33898 5.33898 4.88339 5.33898 4.32203V1.01695C5.33898 0.455593 4.88339 0 4.32203 0H2.2C0.984974 0 0 0.984974 0 2.2Z"
        fill={fill_color}
      />
      <path
        d="M0 2.2V4.32203C0 4.88339 0.455254 5.33898 1.01695 5.33898H4.32203C4.88339 5.33898 5.33898 4.88339 5.33898 4.32203V1.01695C5.33898 0.455593 4.88339 0 4.32203 0H2.2C0.984974 0 0 0.984974 0 2.2Z"
        fill={fill_color}
      />
      <path
        d="M8.34746 0C7.78576 0 7.33051 0.455593 7.33051 1.01695V4.32203C7.33051 4.88339 7.78576 5.33898 8.34746 5.33898H11.6525C12.2139 5.33898 12.6695 4.88339 12.6695 4.32203V1.01695C12.6695 0.455593 12.2139 0 11.6525 0H8.34746Z"
        fill={fill_color}
      />
      <path
        d="M8.34746 0C7.78576 0 7.33051 0.455593 7.33051 1.01695V4.32203C7.33051 4.88339 7.78576 5.33898 8.34746 5.33898H11.6525C12.2139 5.33898 12.6695 4.88339 12.6695 4.32203V1.01695C12.6695 0.455593 12.2139 0 11.6525 0H8.34746Z"
        fill={fill_color}
      />
      <path
        d="M8.34746 0C7.78576 0 7.33051 0.455593 7.33051 1.01695V4.32203C7.33051 4.88339 7.78576 5.33898 8.34746 5.33898H11.6525C12.2139 5.33898 12.6695 4.88339 12.6695 4.32203V1.01695C12.6695 0.455593 12.2139 0 11.6525 0H8.34746Z"
        fill={fill_color}
      />
      <path
        d="M8.34746 0C7.78576 0 7.33051 0.455593 7.33051 1.01695V4.32203C7.33051 4.88339 7.78576 5.33898 8.34746 5.33898H11.6525C12.2139 5.33898 12.6695 4.88339 12.6695 4.32203V1.01695C12.6695 0.455593 12.2139 0 11.6525 0H8.34746Z"
        fill={fill_color}
      />
      <path
        d="M15.678 0C15.1163 0 14.661 0.455593 14.661 1.01695V4.32203C14.661 4.88339 15.1163 5.33898 15.678 5.33898H18.9831C19.5444 5.33898 20 4.88339 20 4.32203V2.2C20 0.984974 19.015 0 17.8 0H15.678Z"
        fill={fill_color}
      />
      <path
        d="M15.678 0C15.1163 0 14.661 0.455593 14.661 1.01695V4.32203C14.661 4.88339 15.1163 5.33898 15.678 5.33898H18.9831C19.5444 5.33898 20 4.88339 20 4.32203V2.2C20 0.984974 19.015 0 17.8 0H15.678Z"
        fill={fill_color}
      />
      <path
        d="M15.678 0C15.1163 0 14.661 0.455593 14.661 1.01695V4.32203C14.661 4.88339 15.1163 5.33898 15.678 5.33898H18.9831C19.5444 5.33898 20 4.88339 20 4.32203V2.2C20 0.984974 19.015 0 17.8 0H15.678Z"
        fill={fill_color}
      />
      <path
        d="M15.678 0C15.1163 0 14.661 0.455593 14.661 1.01695V4.32203C14.661 4.88339 15.1163 5.33898 15.678 5.33898H18.9831C19.5444 5.33898 20 4.88339 20 4.32203V2.2C20 0.984974 19.015 0 17.8 0H15.678Z"
        fill={fill_color}
      />
      <path
        d="M20 8.34746C20 7.7861 19.5444 7.33051 18.9831 7.33051H15.678C15.1163 7.33051 14.661 7.7861 14.661 8.34746V11.6525C14.661 12.2139 15.1163 12.6695 15.678 12.6695H18.9831C19.5444 12.6695 20 12.2139 20 11.6525V8.34746Z"
        fill={fill_color}
      />
      <path
        d="M20 8.34746C20 7.7861 19.5444 7.33051 18.9831 7.33051H15.678C15.1163 7.33051 14.661 7.7861 14.661 8.34746V11.6525C14.661 12.2139 15.1163 12.6695 15.678 12.6695H18.9831C19.5444 12.6695 20 12.2139 20 11.6525V8.34746Z"
        fill={fill_color}
      />
      <path
        d="M20 8.34746C20 7.7861 19.5444 7.33051 18.9831 7.33051H15.678C15.1163 7.33051 14.661 7.7861 14.661 8.34746V11.6525C14.661 12.2139 15.1163 12.6695 15.678 12.6695H18.9831C19.5444 12.6695 20 12.2139 20 11.6525V8.34746Z"
        fill={fill_color}
      />
      <path
        d="M20 8.34746C20 7.7861 19.5444 7.33051 18.9831 7.33051H15.678C15.1163 7.33051 14.661 7.7861 14.661 8.34746V11.6525C14.661 12.2139 15.1163 12.6695 15.678 12.6695H18.9831C19.5444 12.6695 20 12.2139 20 11.6525V8.34746Z"
        fill={fill_color}
      />
      <path
        d="M20 15.678C20 15.1166 19.5444 14.661 18.9831 14.661H15.678C15.1163 14.661 14.661 15.1166 14.661 15.678V18.9831C14.661 19.5444 15.1163 20 15.678 20H17.8C19.015 20 20 19.015 20 17.8V15.678Z"
        fill={fill_color}
      />
      <path
        d="M20 15.678C20 15.1166 19.5444 14.661 18.9831 14.661H15.678C15.1163 14.661 14.661 15.1166 14.661 15.678V18.9831C14.661 19.5444 15.1163 20 15.678 20H17.8C19.015 20 20 19.015 20 17.8V15.678Z"
        fill={fill_color}
      />
      <path
        d="M20 15.678C20 15.1166 19.5444 14.661 18.9831 14.661H15.678C15.1163 14.661 14.661 15.1166 14.661 15.678V18.9831C14.661 19.5444 15.1163 20 15.678 20H17.8C19.015 20 20 19.015 20 17.8V15.678Z"
        fill={fill_color}
      />
      <path
        d="M20 15.678C20 15.1166 19.5444 14.661 18.9831 14.661H15.678C15.1163 14.661 14.661 15.1166 14.661 15.678V18.9831C14.661 19.5444 15.1163 20 15.678 20H17.8C19.015 20 20 19.015 20 17.8V15.678Z"
        fill={fill_color}
      />
      <path
        d="M11.6525 20C12.2139 20 12.6695 19.5444 12.6695 18.9831V15.678C12.6695 15.1166 12.2139 14.661 11.6525 14.661H8.34746C7.78576 14.661 7.33051 15.1166 7.33051 15.678V18.9831C7.33051 19.5444 7.78576 20 8.34746 20H11.6525Z"
        fill={fill_color}
      />
      <path
        d="M11.6525 20C12.2139 20 12.6695 19.5444 12.6695 18.9831V15.678C12.6695 15.1166 12.2139 14.661 11.6525 14.661H8.34746C7.78576 14.661 7.33051 15.1166 7.33051 15.678V18.9831C7.33051 19.5444 7.78576 20 8.34746 20H11.6525Z"
        fill={fill_color}
      />
      <path
        d="M11.6525 20C12.2139 20 12.6695 19.5444 12.6695 18.9831V15.678C12.6695 15.1166 12.2139 14.661 11.6525 14.661H8.34746C7.78576 14.661 7.33051 15.1166 7.33051 15.678V18.9831C7.33051 19.5444 7.78576 20 8.34746 20H11.6525Z"
        fill={fill_color}
      />
      <path
        d="M11.6525 20C12.2139 20 12.6695 19.5444 12.6695 18.9831V15.678C12.6695 15.1166 12.2139 14.661 11.6525 14.661H8.34746C7.78576 14.661 7.33051 15.1166 7.33051 15.678V18.9831C7.33051 19.5444 7.78576 20 8.34746 20H11.6525Z"
        fill={fill_color}
      />
      <path
        d="M4.32203 20C4.88339 20 5.33898 19.5444 5.33898 18.9831V15.678C5.33898 15.1166 4.88339 14.661 4.32203 14.661H1.01695C0.455254 14.661 0 15.1166 0 15.678V17.8C0 19.015 0.984974 20 2.2 20H4.32203Z"
        fill={fill_color}
      />
      <path
        d="M4.32203 20C4.88339 20 5.33898 19.5444 5.33898 18.9831V15.678C5.33898 15.1166 4.88339 14.661 4.32203 14.661H1.01695C0.455254 14.661 0 15.1166 0 15.678V17.8C0 19.015 0.984974 20 2.2 20H4.32203Z"
        fill={fill_color}
      />
      <path
        d="M4.32203 20C4.88339 20 5.33898 19.5444 5.33898 18.9831V15.678C5.33898 15.1166 4.88339 14.661 4.32203 14.661H1.01695C0.455254 14.661 0 15.1166 0 15.678V17.8C0 19.015 0.984974 20 2.2 20H4.32203Z"
        fill={fill_color}
      />
      <path
        d="M4.32203 20C4.88339 20 5.33898 19.5444 5.33898 18.9831V15.678C5.33898 15.1166 4.88339 14.661 4.32203 14.661H1.01695C0.455254 14.661 0 15.1166 0 15.678V17.8C0 19.015 0.984974 20 2.2 20H4.32203Z"
        fill={fill_color}
      />
      <path
        d="M0 11.6525C0 12.2139 0.455254 12.6695 1.01695 12.6695H4.32203C4.88339 12.6695 5.33898 12.2139 5.33898 11.6525V8.34746C5.33898 7.7861 4.88339 7.33051 4.32203 7.33051H1.01695C0.455254 7.33051 0 7.7861 0 8.34746V11.6525Z"
        fill={fill_color}
      />
      <path
        d="M0 11.6525C0 12.2139 0.455254 12.6695 1.01695 12.6695H4.32203C4.88339 12.6695 5.33898 12.2139 5.33898 11.6525V8.34746C5.33898 7.7861 4.88339 7.33051 4.32203 7.33051H1.01695C0.455254 7.33051 0 7.7861 0 8.34746V11.6525Z"
        fill={fill_color}
      />
      <path
        d="M0 11.6525C0 12.2139 0.455254 12.6695 1.01695 12.6695H4.32203C4.88339 12.6695 5.33898 12.2139 5.33898 11.6525V8.34746C5.33898 7.7861 4.88339 7.33051 4.32203 7.33051H1.01695C0.455254 7.33051 0 7.7861 0 8.34746V11.6525Z"
        fill={fill_color}
      />
      <path
        d="M0 11.6525C0 12.2139 0.455254 12.6695 1.01695 12.6695H4.32203C4.88339 12.6695 5.33898 12.2139 5.33898 11.6525V8.34746C5.33898 7.7861 4.88339 7.33051 4.32203 7.33051H1.01695C0.455254 7.33051 0 7.7861 0 8.34746V11.6525Z"
        fill={fill_color}
      />
      <path
        d="M8.34746 7.33051H11.6525C12.2139 7.33051 12.6695 7.7861 12.6695 8.34746V11.6525C12.6695 12.2139 12.2139 12.6695 11.6525 12.6695H8.34746C7.78576 12.6695 7.33051 12.2139 7.33051 11.6525V8.34746C7.33051 7.7861 7.78576 7.33051 8.34746 7.33051Z"
        fill={fill_color}
      />
      <path
        d="M8.34746 7.33051H11.6525C12.2139 7.33051 12.6695 7.7861 12.6695 8.34746V11.6525C12.6695 12.2139 12.2139 12.6695 11.6525 12.6695H8.34746C7.78576 12.6695 7.33051 12.2139 7.33051 11.6525V8.34746C7.33051 7.7861 7.78576 7.33051 8.34746 7.33051Z"
        fill={fill_color}
      />
      <path
        d="M8.34746 7.33051H11.6525C12.2139 7.33051 12.6695 7.7861 12.6695 8.34746V11.6525C12.6695 12.2139 12.2139 12.6695 11.6525 12.6695H8.34746C7.78576 12.6695 7.33051 12.2139 7.33051 11.6525V8.34746C7.33051 7.7861 7.78576 7.33051 8.34746 7.33051Z"
        fill={fill_color}
      />
      <path
        d="M8.34746 7.33051H11.6525C12.2139 7.33051 12.6695 7.7861 12.6695 8.34746V11.6525C12.6695 12.2139 12.2139 12.6695 11.6525 12.6695H8.34746C7.78576 12.6695 7.33051 12.2139 7.33051 11.6525V8.34746C7.33051 7.7861 7.78576 7.33051 8.34746 7.33051Z"
        fill={fill_color}
      />
    </svg>
  );

  return <Icon component={SvgIcon} {...rest} />;
}
